/* eslint-disable no-restricted-imports */
import axios from 'axios';
export * from './is-axios-error';
export { AxiosError, Axios, } from 'axios';
export default axios;
